import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const doSearch = createAsyncThunk('HeaderSearch/doSearch', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('headerSearch', [data.value, 0, 10]);
    return result.Body.items;
  } catch (error) {
    return error;
  }
});

const HeaderSearch = createSlice({
  name: 'headerSearch',
  initialState: {
      searchResult: [],
      openResultSearch: false
  },
  reducers: {
  },
  extraReducers: {
    [doSearch.fulfilled]: (state, action) => {
      state.searchResult = action.payload;
    },
  },
});

export const {} = HeaderSearch.actions;

export default HeaderSearch.reducer;
